import Image, { ImageProps } from "next/image";
import React, { useState } from "react";
import { AppTheme } from "../../helper/enums";

const CustomImage = ({ alt = "", ...props }: ImageProps) => {
  const [src, setSrc] = useState(props.src);

  const isNNTheme = process.env.NEXT_PUBLIC_APP_THEME === AppTheme.nn;
  const fallbackUrl = isNNTheme ? "/images/fallback_img_nn.png" : "/images/fallback_img_nordbayern.png" ; 
  return (
    <>
      <Image
        {...props}
        alt={alt || ""}
        src={src}
        onError={() => setSrc(fallbackUrl)}
        placeholder="blur"
        blurDataURL={fallbackUrl}
      />

    </>
  );
};

export default CustomImage;
